import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexComponent } from './pages/index/index.component';
import { FaqComponent } from './pages/faq/faq.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { CartComponent } from './pages/cart/cart.component';
import { OrderComponent } from './pages/order/order.component';
import { LayoutFooter, LayoutHeader } from './app-routing.enum';
import { PolicyComponent } from './pages/policy/policy.component';
import { OrdercontractComponent } from './pages/ordercontract/ordercontract.component';
import { PreviewComponent } from './pages/preview/preview.component';
import {
  ROUTE_PATH_INDEX,
  ROUTE_PATH_ABOUT,
  ROUTE_PATH_TERMS,
  ROUTE_PATH_POLICY,
  ROUTE_PATH_FAQ,
  ROUTE_PATH_CONTACTS,
  ROUTE_PATH_ORDERCONTRACT,
  ROUTE_PATH_CART,
  ROUTE_PATH_ORDER,
  ROUTE_PATH_404,
  ROUTE_PATH_PREVIEW,
  ROUTE_PATH_ALL_BOOKS,
  ROUTE_PATH_COLLABORATION,
} from './app-routing.constants';
import { AllBooksComponent } from './pages/all-books/all-books.component';
import {
  BOOK_ALIAS_STARRY_DREAM,
  BOOK_ALIAS_WHOS_BIRTHDAY_TOMORROW,
  BOOK_ALIAS_WELCOME_TO_THE_WOLD,
  BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
  BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
} from '@shared/book/constants';
import { CollaborationPageComponent } from './pages/collaboration-page/collaboration-page.component';
import {
  ROUTE_GIFT_BUY,
  ROUTE_GIFT_BUY_SPECIAL,
  ROUTE_GIFT_USE, ROUTE_GIFT_USE_WITH_GIFT_ID,
  ROUTE_GIFT_THANKS, ROUTE_GIFT_ORDER,
  ROUTE_GIFT_ORDER_WITH_ORDER_ID,
  ROUTE_BOOK,
  ROUTE_BOOK_STARRY_DREAM,
  ROUTE_BOOK_WELCOME_TO_THE_WORLD,
  ROUTE_BOOK_WHOS_BIRTHDAY_TOMORROW,
  ROUTE_BOOK_WHERE_IS_BIRTHDAY_CAKE,
  ROUTE_GIFT_USE_NO_LOGO,
  ROUTE_GIFT_USE_NO_LOGO_WITH_GIFT_ID,
  ROUTE_AUTH,
  ROUTE_AUTH_WITH_TYPE,
  ROUTE_MY_PAGE,
  ROUTE_MY_PAGE_WITH_ORDER_ID, ROUTE_BOOK_STORY_OF_GRANDPA_GRANDMA,
} from './routes';




const routes: Routes = [
  { path: 'index', redirectTo: ROUTE_PATH_INDEX, pathMatch: 'full' },
  // { path: 'index' , loadChildren: () => import('./pages/index/index.module').then(m => m.IndexModule) },
  { path: ROUTE_PATH_INDEX , component: IndexComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '子供の名前や誕生日からできる絵本。その子が物語の主人公になる、世界に一冊の特別な絵本を、オーダーメイドで。【税込3,500円～】',
      og_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      og_description: '子供の名前や誕生日からできる絵本。その子が物語の主人公になる、世界に一冊の特別な絵本を、オーダーメイドで。',
      og_url: 'https://hellobuki.com/',
      og_image: 'https://hellobuki.com/assets/images/ogp.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary_large_image',
    }
  },
  { path: ROUTE_PATH_ABOUT, component: AboutComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'About | BÜKIについて',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '子供の豊かで自由な想像の世界を現実にし、子供の世界にもっとワクワクと感動を届けます。',
      og_title: 'BÜKIについて',
      og_description: '子供の豊かで自由な想像の世界を現実にし、子供の世界にもっとワクワクと感動を届けます。',
      og_url: 'https://hellobuki.com/about/',
      og_image: 'https://hellobuki.com/assets/images/ogp-about.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary_large_image'
    }
  },
  { path: ROUTE_PATH_TERMS, component: TermsComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: '利用規約 BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  { path: ROUTE_PATH_POLICY, component: PolicyComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'プライバシーポリシー BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  { path: ROUTE_PATH_FAQ, component: FaqComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'FAQ | よくある質問',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: 'BÜKIのよくある質問はこちら。',
      og_title: 'BÜKIに関するよくある質問',
      og_description: 'BÜKIのよくある質問はこちら。',
      og_url: 'https://hellobuki.com/faq/',
      og_image: 'https://hellobuki.com/assets/images/ogp-buki.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary'
    }
  },
  { path: ROUTE_PATH_CONTACTS, component: ContactsComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'Contact | お問い合わせ',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: 'お問い合わせ内容を確認後、２〜３営業日以内にこちらからご連絡いたします。',
      og_title: 'BÜKIへのお問い合わせ',
      og_description: 'お問い合わせ内容を確認後、２〜３営業日以内にこちらからご連絡いたします。',
      og_url: 'https://hellobuki.com/contacts/',
      og_image: 'https://hellobuki.com/assets/images/ogp-buki.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/contacts/',
    }
  },
  { path: ROUTE_PATH_ORDERCONTRACT, component: OrdercontractComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: '特定商取引法に基づく表示 BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  { path: ROUTE_PATH_CART, component: CartComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'Cart | カート',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  { path: ROUTE_PATH_ORDER, component: OrderComponent, data: {
      LayoutHeader: LayoutHeader.hidden,
      LayoutFooter: LayoutFooter.hidden,
      title: 'Checkout | お会計',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  ROUTE_BOOK,
  ROUTE_BOOK_STARRY_DREAM,
  ROUTE_BOOK_WELCOME_TO_THE_WORLD,
  ROUTE_BOOK_WHOS_BIRTHDAY_TOMORROW,
  ROUTE_BOOK_WHERE_IS_BIRTHDAY_CAKE,
  ROUTE_BOOK_STORY_OF_GRANDPA_GRANDMA,
  { path: ROUTE_PATH_ALL_BOOKS, component: AllBooksComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'Books | BÜKIの絵本棚',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '物語の主人公になれる絵本BÜKの絵本棚。どの物語の主人公になって、冒険の旅にでかけよう？',
      og_title: 'BÜKIの絵本棚',
      og_description: '物語の主人公になれる絵本BÜKの絵本棚。どの物語の主人公になって、冒険の旅にでかけよう？！',
      og_url: 'https://hellobuki.com/all-books/',
      og_image: 'https://hellobuki.com/assets/images/ogp-all-books.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/all-books/',
    }
  },
  { path: ROUTE_PATH_404, component: NotFoundComponent, data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.hidden,
      title: '404 BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）'
    }
  },
  { path: BOOK_ALIAS_STARRY_DREAM,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'ほしのゆめ BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '「ほしのゆめ」星座に導かれて、不思議な星の旅へ。主人公の成長を願う星の物語。【税込3,900円～】',
      og_title: 'ほしのゆめ',
      og_description: '「ほしのゆめ」星座に導かれて、不思議な星の旅へ。主人公の成長を願う星の物語。',
      og_url: 'https://hellobuki.com/starry-dream/',
      og_image: 'https://hellobuki.com/assets/images/ogp-starry-dream.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/starry-dream/',
    }
  },
  { path: BOOK_ALIAS_WELCOME_TO_THE_WOLD,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'ようこそ、このせかいへ BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '「ようこそ、このせかいへ」あなたがこの世界の素敵な魔法に,たくさん出会えますように。【税込3,700円～】',
      og_title: 'ようこそ、このせかいへ',
      og_description: '「ようこそ、このせかいへ」あなたがこの世界の素敵な魔法に、たくさん出会えますように。',
      og_url: 'https://hellobuki.com/welcome-to-the-world/',
      og_image: 'https://hellobuki.com/assets/images/ogp-welcome-to-the-world.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/welcome-to-the-world/',
    }
  },
  { path: BOOK_ALIAS_WHOS_BIRTHDAY_TOMORROW,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'あしたはだれのたんじょうび？ BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '「あしたはだれのたんじょうび？」明日は一年のなかで一番、特別な日。最高のお誕生日パーティにしよう！【税込3,500円～】',
      og_title: 'あしたはだれのたんじょうび？',
      og_description: '「あしたはだれのたんじょうび？」明日は一年のなかで一番、特別な日。最高のお誕生日パーティにしよう！',
      og_url: 'https://hellobuki.com/whos-birthday-tomorrow/',
      og_image: 'https://hellobuki.com/assets/images/ogp-whos-birthday-tomorrow.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/whos-birthday-tomorrow/',
    }
  },
  { path: BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'みつけて！たんじょうびまでのだいぼうけん BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '「みつけて！たんじょうびまでのだいぼうけん」お誕生日の”探す”絵本！1月、2月・・、お友達が無くしたものは、１年のどこにある？見つけたものを合わせると、サプライズが！【税込3,990円～】',
      og_title: 'みつけて！たんじょうびまでのだいぼうけん',
      og_description: '「みつけて！たんじょうびまでのだいぼうけん」お誕生日の”探す”絵本！1月、2月・・、お友達が無くしたものは、１年のどこにある？見つけたものを合わせると、サプライズが！',
      og_url: 'https://hellobuki.com/' + BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
      og_image: 'https://hellobuki.com/assets/images/ogp-where-is-birthday-cake.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/' + BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
    }
  },
  { path: BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'わたしたちの、おじいちゃん/おばあちゃん BÜKI',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: '「わたしたちの、おじいちゃん/おばあちゃん」僕の私のおじいちゃん・おばあちゃんが絵本の主人公！大切な子に読みたい、おじいちゃん・おばあちゃんの心温まるストーリー【税込4,000円～】',
      og_title: 'わたしたちの、おじいちゃん/おばあちゃん',
      og_description: '「わたしたちの、おじいちゃん/おばあちゃん」僕の私のおじいちゃん・おばあちゃんが絵本の主人公！大切な子に読みたい、おじいちゃん・おばあちゃんの心温まるストーリー',
      og_url: 'https://hellobuki.com/' + BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
      og_image: 'https://hellobuki.com/assets/images/ogp-story-of-grandpa-grandma.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary',
      twitter_site: 'https://hellobuki.com/' + BOOK_ALIAS_STORY_OF_GRANDPA_GRANDMA,
    }
  },
  ROUTE_GIFT_BUY,
  ROUTE_GIFT_BUY_SPECIAL,
  ROUTE_GIFT_USE,
  ROUTE_GIFT_USE_WITH_GIFT_ID,
  ROUTE_GIFT_USE_NO_LOGO,
  ROUTE_GIFT_USE_NO_LOGO_WITH_GIFT_ID,
  ROUTE_GIFT_THANKS,
  ROUTE_GIFT_ORDER,
  ROUTE_GIFT_ORDER_WITH_ORDER_ID,
  ROUTE_AUTH,
  ROUTE_AUTH_WITH_TYPE,
  ROUTE_MY_PAGE,
  ROUTE_MY_PAGE_WITH_ORDER_ID,
  {
    path: ROUTE_PATH_COLLABORATION,
    component: CollaborationPageComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'Collaboration | 法人向けサービス',
      meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      description: 'BÜKIのデジタル・テクノロジーを使って、一緒に小さなお客さまに特別な一冊を提供しませんか？パーソナライズ絵本の出版や景品利用など、お問い合わせください。',
      og_title: '法人向けサービス',
      og_description: 'BÜKIのデジタル・テクノロジーを使って、一緒に小さなお客さまに特別な一冊を提供しませんか？パーソナライズ絵本の出版や景品利用など、お問い合わせください。',
      og_url: 'https://hellobuki.com/collaboration/',
      og_image: 'https://hellobuki.com/assets/images/ogp-buki.jpg',
      og_site_name: 'BÜKI（ブーキー）',
      fb_app_id: '174662759861666',
      og_type: 'website',
      twitter_card: 'summary'
    },
  },
  {
    path: ROUTE_PATH_PREVIEW,
    component: PreviewComponent,
    data: {
      LayoutHeader: LayoutHeader.shown,
      LayoutFooter: LayoutFooter.shown,
      title: 'Book | プレビュー',
      // defined on the backend
      // meta_title: 'BÜKI 物語の主人公になれる絵本（ブーキー）',
      // og_url: 'https://hellobuki.com/',
    }
  },
  { path: '**', redirectTo: ROUTE_PATH_404 }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 100],
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
